export default __webpack_public_path__ + "static/media/yahia.a51c6cd6.jpg";